import React, { useState } from "react";
import "./LearnVideo.css";

const LearnVideo = ({ title, videoUrl, description }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="learn-video">
      <div className="learn-video__inner">
        <div className="learn-video__header">
          <div>
            <h3 className="learn-video__title">{title}</h3>
            <p className="learn-video__description">{description}</p>
          </div>

          <button
            className="learn-video__toggle"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "Hide video" : "Watch video"}
          </button>
        </div>

        {expanded && (
          <div className="learn-video__frame-wrapper">
            <iframe
              src={videoUrl}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className="learn-video__frame"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LearnVideo;